var avatarData = {
  name: 'avatar',
  data: [{
    c7nSquareBorderRadius: '0.06rem'
  }]
};
export default avatarData;